import { sprintf } from '../../../vendor/sprintf-js/src/sprintf';

import infraConfig from '../../config.json';

class Endpoint {
  static createFromData(data) {
    const endpoint = new Endpoint();
    endpoint.data = data;
    endpoint.postProcessed = false;

    return endpoint;
  }

  static floatToBin(f) {
    const i = Math.round(f * 1000.0);
    return sprintf('%+019b', i);
  }

  static latLngToCoords(lat, lon) {
    let coords = '';
    // console.log('data');

    const slat = Endpoint.floatToBin(lat);
    const slon = Endpoint.floatToBin(lon);
    // console.log(slat);
    // console.log(slon);

    if (slat.length !== slon.length) {
      // window.alert(`length mismatch: ${slat} vs ${slon}`);
    }

    for (let i = 0; i < slat.length; i += 1) {
      const chlat = slat.charAt(i);
      const chlon = slon.charAt(i);

      coords += chlat + chlon;
    }

    return coords;
  }

  static coordsToLatLng(coords) {
    let latBin = '';
    let lonBin = '';
    let deltaLatBin = '1';
    let deltaLonBin = '1';

    for (let i = 0; i < 38; i += 2) {
      if (i < coords.length) {
        latBin += coords.charAt(i);
        let lonChar = coords.charAt(i + 1);
        if (lonChar === '') {
          lonChar = '0';
          deltaLonBin += '0';
        }
        lonBin += lonChar;
      } else {
        latBin += '0';
        lonBin += '0';
        deltaLatBin += '0';
        deltaLonBin += '0';
      }
    }

    // console.log('latBin');
    // console.log(latBin);
    // console.log('lonBin');
    // console.log(lonBin);

    let latMin = parseInt(latBin, 2);
    let lonMin = parseInt(lonBin, 2);
    let deltaLat = parseInt(deltaLatBin, 2);
    let deltaLon = parseInt(deltaLonBin, 2);
    if (latBin.charAt(0) === '-') { latMin -= 1; }
    if (lonBin.charAt(0) === '-') { lonMin -= 1; }

    // console.log('latMin');
    // console.log(latMin);
    // console.log('lonMin');
    // console.log(lonMin);
    // console.log('deltaLat');
    // console.log(deltaLat);
    // console.log('deltaLon');
    // console.log(deltaLon);

    latMin /= 1000.0;
    lonMin /= 1000.0;
    deltaLat /= 1000.0;
    deltaLon /= 1000.0;
    // console.log('latMin');
    // console.log(latMin);
    // console.log('lonMin');
    // console.log(lonMin);
    // console.log('deltaLat');
    // console.log(deltaLat);
    // console.log('deltaLon');
    // console.log(deltaLon);

    return {
      // latAvg: latMin + deltaLat / 2,
      latAvg: latMin >= 0 ? latMin + deltaLat / 2 : latMin - deltaLat / 2,
      lonAvg: lonMin >= 0 ? lonMin + deltaLon / 2 : lonMin - deltaLon / 2,
      latDelta: deltaLat,
      lonDelta: deltaLon,
    };
  }

  static countZeroes(bin) {
    // return the location of the first non-zero
    for (let i = 1; i < bin.length; i += 1) {
      if (bin.charAt(i) !== '0') {
        return i + 2;
      }
    }

    return bin.length;
  }

  static deltaToCoordsPrefixLen(latDelta, lonDelta) {
    const latDeltaBin = Endpoint.floatToBin(latDelta);
    const lonDeltaBin = Endpoint.floatToBin(lonDelta);

    let latDeltaPrefixLen = Endpoint.countZeroes(latDeltaBin);
    let lonDeltaPrefixLen = Endpoint.countZeroes(lonDeltaBin);
    if (latDeltaPrefixLen > lonDeltaPrefixLen + 1) {
      latDeltaPrefixLen = lonDeltaPrefixLen + 1;
    }
    if (lonDeltaPrefixLen > latDeltaPrefixLen + 1) {
      lonDeltaPrefixLen = latDeltaPrefixLen + 1;
    }
    return latDeltaPrefixLen + lonDeltaPrefixLen;
  }

  static getImageThumbnail(image) {
    const { uuid } = image;
    const prefix = uuid.substring(6, 8)
      + uuid.substring(4, 6)
      + uuid.substring(2, 4)
      + uuid.substring(0, 2);
    let index = parseInt(prefix, 16) % 100;
    index += 100;
    index = index.toString().substr(-2, 2);

    return `https://${infraConfig.imagesThumbs128Bucket}.s3-${infraConfig.region}.amazonaws.com/${index}/${uuid}`;
  }

  static getImage(image, token, app) {
    const { uuid } = image;

    return `${infraConfig.imagesApiUrl}/image-hd?id=${uuid}&app=${app}&token=${token}`;
  }

  constructor(app) {
    this.data = {
      __typename: 'Endpoint',
      uuid: 1,
      app,
      // lat: 37.78825,
      // lon: -122.4324,
      images: '[]',
      // TODO(clairbee): set defaults for other fields as well
    };
  }

  makeOptimistic() {
    if (!this.data.uuid) {
      this.data.uuid = 'not-inserted-yet-%s' % Math.random().toString();
    }
    return this;
  }

  output() {
    const coords = Endpoint.latLngToCoords(this.data.lat, this.data.lon);

    this.data.coords = coords;
    // console.log('output');
    // console.log(this.data);
    return this.data;
  }

  postProcess() {
    if (this.postProcessed) {
      return;
    }
    this.postProcessed = true;

    this.pp = {};
    this.pp.link = `/endpoint/${this.data.uuid}`;
    this.pp.uuid = this.data.uuid;
    this.pp.app = this.data.app;
    this.pp.images = [];
    this.pp.proto = { input: [], output: [] };
    if (this.data.images && this.data.images !== '') {
      try {
        this.pp.images = JSON.parse(this.data.images);
      } catch (e) {
        console.log('error parsing images');
        console.log(e);
      }
    }
    if (this.data.proto && this.data.proto !== '') {
      try {
        this.pp.proto = JSON.parse(this.data.proto);
      } catch (e) {
        console.log('error parsing proto');
        console.log(e);
      }
    }
    // TODO(clairbee): post process other fields
  }

  isPublisher(uuidMe) {
    return this.data.user !== undefined && this.data.user === uuidMe;
  }

  isPurchased() {
    return false; // TODO(clairbee): not implemented yet
  }

  isFullTrackAccessible(uuidMe) {
    return this.isPublisher(uuidMe) || this.isPurchased();
  }

  getTrackS3Path() {
    const uuid = this.data.track;
    const prefix = uuid.substring(6, 8)
      + uuid.substring(4, 6)
      + uuid.substring(2, 4)
      + uuid.substring(0, 2);
    let index = parseInt(prefix, 16) % 100;
    index += 100;
    index = index.toString().substr(-2, 2);

    return `${index}/${uuid}`;
  }

  getTrackPreview() {
    if (infraConfig.envName !== 'prod') {
      return `https://${infraConfig.audioMiniBucket}.s3-${infraConfig.region}.amazonaws.com/${this.getTrackS3Path()}`;
    }
    return `https://${infraConfig.domainName}/${this.getTrackS3Path()}`;
  }

  getTrackPublisher(token) {
    // return this.getTrackS3('gmt-mini');
    // return `https://ak1doksp20.execute-api.us-west-2.amazonaws.com/prod/track-norm?id=${this.data.track}&token=${token}`;
    return `${infraConfig.audioApiUrl}/track-norm?id=${this.data.track}&app=${this.data.app}&token=${token}`;
  }
}

export default Endpoint;
